import React from "react";
import BaseReactSelectDropdown from "./BaseReactSelectDropdown";
import { useQuery } from "@tanstack/react-query";
import { type DropdownProps } from "../models";

interface Props extends DropdownProps<server.dto.StatusSmall> {
  mainArea: server.dto.MainAreas;
  clientId: number;
}

const StatusDropdown = (props: Props) => {
  const previousMainArea = React.useRef(props.mainArea);
  const query = useQuery({
    queryFn: async () => window.CoreApi.Status.ListSmall({ clientId: props.clientId, mainArea: props.mainArea }).then(r => r.data.data),
    queryKey: ["statuses", props.mainArea, props.clientId],
    enabled: !props.options,
    initialData: props.options ?? [],
    onSuccess: (res) => {
      if (previousMainArea.current !== props.mainArea) {
        props.onChange(res[0]);
        previousMainArea.current = props.mainArea;
      }
    }
  });

  return <BaseReactSelectDropdown
    excludeKeys={props.excludeKeys}
    options={query.data}
    getLabel={status => status.title}
    getValue={status => status.statusId}
    value={props.value}
    onChange={props.onChange}
    config={{
      isSearchable: false,
      ...props.config
    }}
    renderOption={(status) => <div className="flex align-center">
      <div className="ui circular empty label" style={{ backgroundColor: status.hexColor, marginRight: 10 }}></div>
      <span>{status.title}</span>
    </div>}
    renderSelectedValue={(status) => <div className="flex align-center">
      <div className="ui circular empty label" style={{ backgroundColor: status.hexColor, marginRight: 10 }}></div>
      <span>{status.title}</span>
    </div>}
  />;
};

export default StatusDropdown;